import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { useLocation, useNavigate } from 'react-router';
import '../Customer/CustomerScreens.scss';

const DEFAULT_FAILURE_TITLE = 'Payment Failed';
const DEFAULT_FAILURE_MESSAGE =
  'We could not complete your payment. Please try again or switch to another payment method.';

export default function PaymentFailure() {
  const navigate = useNavigate();
  const location = useLocation();

  const failureTitle =
    location.state?.failureTitle?.trim() || DEFAULT_FAILURE_TITLE;
  const failureMessage =
    location.state?.failureMessage?.trim() || DEFAULT_FAILURE_MESSAGE;

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Payment</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        <Paper className='customer-card' sx={{ p: 3 }}>
          <Box className='checkout-successWrap'>
            <Box className='checkout-successBadge checkout-successBadge--error'>
              <ErrorOutlineRoundedIcon sx={{ fontSize: 56 }} />
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: '2rem', mb: 1 }}>
              {failureTitle}
            </Typography>
            <Typography className='customer-muted' sx={{ mb: 3, maxWidth: 420 }}>
              {failureMessage}
            </Typography>
          </Box>
        </Paper>

        <Paper className='checkout-stickyFooter'>
          <Button
            className='customer-actionButton customer-actionButton--primary'
            fullWidth
            onClick={() => navigate('/checkout/payment-methods', { state: location.state })}
          >
            Try Payment Again
          </Button>
          <Button
            fullWidth
            sx={{ mt: 1.5, color: '#ff5c67', fontWeight: 700, textTransform: 'none' }}
            onClick={() => navigate('/support')}
          >
            Contact Support
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
